/* Extracted from sections/concierge.liquid, previously a {% javascript %} block, loaded with defer at the end of that section. */
  (function () {
    /* Bind to the drawer itself, and only if it is really the drawer. This selector is
       document-wide, so any other element carrying data-cncg anywhere on the page could win it and
       leave threadEl/formEl null - which is exactly what happened when the configurator's brief
       panel shared the attribute: this script threw on the first addEventListener and the assistant
       was dead on that page. Degrade quietly instead of taking the page's JS down with us. */
    var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cncg = document.querySelector('.cncg[data-cncg]') || document.querySelector('[data-cncg]');
    if (!cncg || !cncg.querySelector('[data-cncg-thread]') || !cncg.querySelector('[data-cncg-form]')) return;
    /* The fallback copy used to hardcode the number, so changing the Store phone theme setting
       left the chat quoting the old one. */
    var CNCG_PHONE = cncg.getAttribute('data-phone') || '1800 100 998';
    var panel = cncg.querySelector('.cncg__panel');
    var threadEl = cncg.querySelector('[data-cncg-thread]');
    var formEl = cncg.querySelector('[data-cncg-form]');
    var inputEl = cncg.querySelector('[data-cncg-input]');
    var opener = null, busy = false, greeted = false, greetedHandle = null, seedAsk = null;
    var history = [];
    var lastShown = [];   // full product objects most recently shown (for "compare"/"these")
    var intentTerms = ''; // sticky canonical search terms for the current intent

    function proxy() { return (window.CHT_ACCOUNT && window.CHT_ACCOUNT.proxy) || '/apps/cht'; }
    /* One envelope across every tool on the site - event, tool, action - so a single GTM trigger
       covers the lot. The cht:concierge CustomEvent is kept alongside the new cht:tool one so
       anything already listening for it keeps working. */
    /* The customer types free text, so anything derived from it can carry a phone number or an
       email address. GA4's terms prohibit receiving those, and the dataLayer is readable by every
       other tag on the page, so scrub before the push rather than trusting each tag to behave.
       Mirrors scrubPii() in the worker, which does the same job on the server-side chat log. */
    function scrubPii(v) {
      return String(v == null ? '' : v)
        .replace(/[\w.+-]+@[\w-]+\.[\w.]+/g, '[email]')
        .replace(/(?:\+?61|0)[\s-]?[234578](?:[\s-]?\d){8}/g, '[phone]')
        .replace(/\b1[38]00[\s-]?\d{3}[\s-]?\d{3}\b/g, '[phone]');
    }
    function track(ev, data) {
      try {
        var d = Object.assign({ event: 'cht_tool', tool: 'concierge', action: ev }, data || {});
        if (typeof d.q === 'string') d.q = scrubPii(d.q).slice(0, 140);
        if (typeof d.label === 'string') d.label = scrubPii(d.label).slice(0, 140);
        (window.dataLayer = window.dataLayer || []).push(d);
        window.dispatchEvent(new CustomEvent('cht:tool', { detail: d }));
        window.dispatchEvent(new CustomEvent('cht:concierge', { detail: d }));
      } catch (e) {}
    }
    function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }
    function money(c) { if (c == null || c === '') return ''; c = Math.round(Number(c) || 0); var n = c / 100; return '$' + (c % 100 === 0 ? n.toLocaleString('en-AU') : n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); }
    function scroll() { threadEl.scrollTop = threadEl.scrollHeight; }

    /* ---- session persistence (survives page navigation) ---- */
    function saveHist() { try { sessionStorage.setItem('cht_assist', JSON.stringify(history.slice(-12))); } catch (e) {} }
    /* Anonymous per-tab session id so multi-turn chats can be linked in the (PII-free) chat log. */
    function sid() {
      try {
        var v = sessionStorage.getItem('cht_assist_sid');
        if (!v) { v = Math.random().toString(36).slice(2, 10); sessionStorage.setItem('cht_assist_sid', v); }
        return v;
      } catch (e) { return ''; }
    }
    function loadHist() { try { return JSON.parse(sessionStorage.getItem('cht_assist') || '[]') || []; } catch (e) { return []; } }

    function open(o) {
      opener = o || document.activeElement;
      var ask = o && o.getAttribute && o.getAttribute('data-cncg-ask');
      if (ask) seedAsk = { title: ask, handle: (o.getAttribute('data-cncg-handle') || ''), type: (o.getAttribute('data-cncg-type') || '') };
      cncg.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false');
      if (window.CHT && CHT.scrollLock) { CHT.scrollLock.lock(); } else { document.documentElement.style.overflow = 'hidden'; }
      // Opened generically on a product page (e.g. the floating launcher) with no prior chat:
      // greet with product context instead of the generic hello.
      if (!seedAsk && !greeted && location.pathname.indexOf('/products/') >= 0 && loadHist().length === 0) {
        var _og = document.querySelector('meta[property="og:title"]');
        var _t = _og && _og.content ? _og.content.trim() : '';
        if (_t) { seedAsk = { title: _t, handle: location.pathname.split('/products/')[1].split(/[?#]/)[0], type: '' }; }
      }
      if (seedAsk && greetedHandle !== seedAsk.handle) { greetProduct(seedAsk); greeted = true; greetedHandle = seedAsk.handle; }
      else if (!greeted) { greeted = true; var prior = loadHist(); if (prior.length) { history = prior; prior.forEach(function (m) { if (m.role === 'user') { addUser(m.text); } else { addBot(m.text, m.picks || null, m.refines || null, m.note || null); if (m.picks && m.picks.length) { lastShown = m.picks.map(function (x) { return x.p; }); } } }); } else { greet(); } }
      track('open', { seeded: !!seedAsk });
      var prefill = o && o.getAttribute && o.getAttribute('data-cncg-prefill');
      if (prefill && inputEl && !inputEl.value) { inputEl.value = prefill; }
      setTimeout(function () { try { inputEl.focus(); if (prefill) inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length); } catch (e) {} }, 80);
    }
    function close() { cncg.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); if (window.CHT && CHT.scrollLock) { CHT.scrollLock.unlock(); } else { document.documentElement.style.overflow = ''; } if (opener && opener.focus) try { opener.focus(); } catch (e) {} }

    function ctx() {
      var c = { page: 'other' }, p = location.pathname;
      if (seedAsk && seedAsk.title) { c.page = 'product'; c.productTitle = seedAsk.title; return c; }
      if (p.indexOf('/products/') >= 0) { c.page = 'product'; var og = document.querySelector('meta[property="og:title"]'); if (og && og.content) c.productTitle = og.content; }
      else if (p.indexOf('/collections/') >= 0) { c.page = 'collection'; }
      return c;
    }

    /* ---- render ---- */
    function addUser(text) { var d = document.createElement('div'); d.className = 'cncg-msg cncg-msg--user'; d.innerHTML = '<div class="cncg-bubble">' + esc(text) + '</div>'; threadEl.appendChild(d); scroll(); }
    function addTyping() { var d = document.createElement('div'); d.className = 'cncg-msg cncg-msg--bot cncg-msg--typing'; d.innerHTML = '<span class="cncg-orb-sm" aria-hidden="true"></span><div class="cncg-bubble"><span class="cncg-dots" aria-hidden="true"><i></i><i></i><i></i></span><span class="cncg-step" role="status" aria-live="polite"></span></div>'; threadEl.appendChild(d); scroll(); return d; }
    /* sc6: what Soundcheck is doing while it works ("Searching subwoofers…"). Real steps stream from
       the worker; until the first one arrives, a guess from the question fills the gap. */
    (function () {
      if (document.getElementById('cncg-step-css')) return;
      var st = document.createElement('style'); st.id = 'cncg-step-css';
      st.textContent = '.cncg-msg--typing .cncg-bubble{display:flex;align-items:center;gap:10px}.cncg-step{font-size:13px;line-height:1.35;color:var(--c-text-2,#5b6372);transition:opacity .2s}.cncg-step:empty{display:none}.cncg-step.is-swap{opacity:0}';
      document.head.appendChild(st);
    })();
    function setStep(typing, text) {
      var el = typing && typing.querySelector && typing.querySelector('.cncg-step'); if (!el || !text || el.textContent === text) return;
      el.classList.add('is-swap');
      setTimeout(function () { el.textContent = text; el.classList.remove('is-swap'); scroll(); }, 160);
    }
    var STEP_CATS = [[/\bsubs?\b|subwoofer/i, 'subwoofers'], [/\breceivers?\b|\bavr\b|\bprocessor/i, 'AV receivers'], [/projector/i, 'projectors'], [/\bscreens?\b/i, 'screens'], [/turntable|record player|vinyl/i, 'turntables'], [/\bcables?\b|hdmi/i, 'cables'], [/\bamps?\b|amplifier/i, 'amplifiers'], [/stream/i, 'streamers'], [/speaker|floorstand|bookshelf|ceiling|atmos/i, 'speakers'], [/acoustic|panel|treatment|echo|reverb/i, 'acoustic treatment']];
    function guessStep(q, focus) {
      if (focus && focus.title) return 'Reading the ' + focus.title.slice(0, 50) + ' details…';
      for (var i = 0; i < STEP_CATS.length; i++) { if (STEP_CATS[i][0].test(q)) return 'Looking through our ' + STEP_CATS[i][1] + '…'; }
      return 'Thinking it through…';
    }
    /* Reads the worker's reply: NDJSON when it streams (steps, then the final object), plain JSON otherwise. */
    function readAssist(r, onStep) {
      if (!r || !r.ok) return Promise.resolve(null);
      var ct = (r.headers && r.headers.get('content-type')) || '';
      if (ct.indexOf('ndjson') < 0) return r.json().catch(function () { return null; });
      var final = null, buf = '';
      function eat(chunk) {
        buf += chunk;
        var lines = buf.split('\n'); buf = lines.pop();
        lines.forEach(function (ln) { if (!ln) return; try { var o = JSON.parse(ln); if (o.final) final = o.final; else if (o.step) onStep(o.step); } catch (e) {} });
      }
      if (!r.body || !r.body.getReader || !window.TextDecoder) return r.text().then(function (t) { eat(t + '\n'); return final; });
      var reader = r.body.getReader(), dec = new TextDecoder();
      function pump() { return reader.read().then(function (x) { if (x.done) { eat(dec.decode() + '\n'); return final; } eat(dec.decode(x.value, { stream: true })); return pump(); }); }
      return pump();
    }

    function card(p, why) {
      var img = p.image ? '<span class="cncg-pc__img"><img src="' + esc(p.image) + '" alt="" loading="lazy"></span>' : '<span class="cncg-pc__img"></span>';
      var line = why || p.blurb || '';
      var isPoa = !!p.poa;
      var pr = isPoa ? '<span class="cncg-pc__spec">◆ By specification</span>' : (money(p.price) ? '<span class="cncg-pc__price">' + money(p.price) + '</span>' : '');
      var stock = (!isPoa && p.available === false) ? '<span class="cncg-pc__oos">Backorder</span>' : '';
      var canAdd = !isPoa && p.vid && p.available !== false && Number(p.variants) === 1;
      var add = canAdd ? '<button type="button" class="cncg-pc__add" data-add-vid="' + esc(p.vid) + '" data-add-title="' + esc(p.title) + '">Add</button>' : '';
      var viewLabel = isPoa ? 'Enquire →' : 'View →';
      return '<div class="cncg-pc">' +
        '<a class="cncg-pc__link" href="' + esc(p.url) + '" data-view-handle="' + esc(p.handle) + '">' + img +
          '<span class="cncg-pc__main">' +
            (p.vendor ? '<span class="cncg-pc__brand">' + esc(p.vendor) + '</span>' : '') +
            '<span class="cncg-pc__name">' + esc(p.title) + '</span>' +
            (line ? '<span class="cncg-pc__why">' + esc(line) + '</span>' : '') +
          '</span>' +
        '</a>' +
        '<div class="cncg-pc__foot">' + pr + stock +
          '<span class="cncg-pc__acts">' + add + '<a class="cncg-pc__view" href="' + esc(p.url) + '" data-view-handle="' + esc(p.handle) + '">' + viewLabel + '</a></span>' +
        '</div>' +
      '</div>';
    }
    function quickAdd(btn) {
      var vid = btn.getAttribute('data-add-vid'); if (!vid) return;
      var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      track('quick_add', { vid: vid, title: btn.getAttribute('data-add-title') });
      fetch(routes + 'cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json', 'accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { btn.disabled = false; btn.textContent = orig; if (window.CHT && CHT.toast) CHT.toast((res.d && res.d.description) || 'Could not add to cart'); return; }
          btn.textContent = 'Added ✓';
          if (window.CHT && CHT.cart && CHT.cart.refresh) CHT.cart.refresh(true);
          else if (window.CHT && CHT.refreshCartCount) CHT.refreshCartCount();
        })
        .catch(function () { btn.disabled = false; btn.textContent = orig; if (window.CHT && CHT.toast) CHT.toast('Could not add to cart'); });
    }

    function snapPicks(picks) {
      return (picks || []).slice(0, 4).map(function (x) {
        var p = x.p || {};
        return { p: { handle: p.handle, url: p.url, image: p.image, vendor: p.vendor, title: p.title, blurb: p.blurb, poa: p.poa, price: p.price, available: p.available, vid: p.vid, variants: p.variants }, why: x.why || '' };
      });
    }
    function addBot(answer, picks, refines, note) {
      var html = '<span class="cncg-orb-sm" aria-hidden="true"></span><div class="cncg-bubble">';
      if (answer) html += '<p class="cncg-ans">' + esc(answer) + '</p>';
      if (picks && picks.length) html += '<div class="cncg-cards">' + picks.map(function (x) { return card(x.p, x.why); }).join('') + '</div>';
      if (note) html += '<p class="cncg-note">' + esc(note) + '</p>';
      if (refines && refines.length) html += '<div class="cncg-refines">' + refines.map(function (r) { return '<button type="button" class="cncg-refine" data-terms="' + esc(r.terms || '') + '">' + esc(r.label) + '</button>'; }).join('') + '</div>';
      html += '</div>';
      var d = document.createElement('div'); d.className = 'cncg-msg cncg-msg--bot'; d.innerHTML = html; threadEl.appendChild(d); scroll();
    }

    function greet() {
      addBot('Hi, I’m Soundcheck, CHT’s AV assistant. Tell me what you’re after (a receiver with certain features, a turntable, speakers for a room) and I’ll find the right options. Ask me anything.', null, [
        { label: 'AV receiver with HDMI 2.1', terms: 'av receiver hdmi 2.1' },
        { label: 'Turntable with built-in phono', terms: 'turntable phono preamp' },
        { label: 'Floorstanding speakers', terms: 'floorstanding speakers' }
      ], null);
    }
    function greetProduct(sp) {
      var alt = sp.type || sp.title;
      addBot('Happy to help with the ' + sp.title + '. What would you like to know?', null, [
        { label: 'Is it right for me?', terms: sp.title },
        { label: 'A cheaper option?', terms: alt },
        { label: 'A step up?', terms: alt }
      ], null);
    }

    /* ---- retrieval (Shopify search, whole catalogue) ---- */
    /* Product on screen: full description + specs fetched once (?view=assist), sent as "focus" with
       every question on a PDP and prepended to the candidates, so "what are the dimensions of this"
       is answered from this product's own text instead of whatever the search returned. */
    var focusCache = null, focusHandle = null;
    function focusProduct() {
      var h = (seedAsk && seedAsk.handle) || (location.pathname.indexOf('/products/') >= 0 ? location.pathname.split('/products/')[1].split(/[?#]/)[0] : '');
      h = String(h || '').replace(/[^a-z0-9-]/gi, '');
      if (!h) return Promise.resolve(null);
      if (focusCache && focusHandle === h) return Promise.resolve(focusCache);
      focusHandle = h;
      // No "accept: application/json": with it Shopify answers with its own product JSON and ignores ?view=assist.
      return fetch(routes + 'products/' + encodeURIComponent(h) + '?view=assist')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { try { var j = JSON.parse(t); if (j && j.handle) { focusCache = j; return j; } } catch (e) {} return null; })
        .catch(function () { return null; });
    }
    function search1(terms) {
      return fetch(routes + 'search?q=' + encodeURIComponent(terms) + '&type=product&view=assist&resources[limit]=12', { headers: { 'accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { try { var j = JSON.parse(t); return (j && j.products) || []; } catch (e) { return predictive(terms); } })
        .catch(function () { return predictive(terms); });
    }
    /* Store search finds nothing for a whole sentence ("best ported sub for movies around $2k"), so
       when the sentence comes back empty, retry with its key words, then fewer of them (product
       word first). Mirrored in worker/eval/run.mjs so the eval sees the same products. */
    var SC_STOP = 'i,im,me,my,we,our,a,an,the,and,or,for,to,of,in,on,at,with,from,by,is,are,be,it,its,this,that,these,those,do,does,you,your,have,has,got,get,want,wanting,need,needs,looking,look,after,best,good,great,top,recommend,recommendation,suggest,which,what,whats,how,much,many,can,could,would,should,will,any,some,something,anything,around,about,under,over,below,above,between,budget,price,cost,up,than,more,less,cheap,cheaper,expensive,please,thanks,help,hi,hello,like,really,very,just,also,new,one,ones,options,option,ideally,maybe,there,here,sale,sell,stock,buy,bit,come,suit,suits,big,small,vs,versus,room,rooms,house,square,metre,metres,meter,inch,inches,system,setup,into,work,works,lots,whether,go,goes,used,use'.split(',');
    var SC_SYN = { sub: 'subwoofer', subs: 'subwoofer', subwoofers: 'subwoofer', amp: 'amplifier', amps: 'amplifier', avr: 'receiver', receivers: 'receiver', speakers: 'speaker', projectors: 'projector', screens: 'screen', turntables: 'turntable', cables: 'cable', headphones: 'headphones' };
    var SC_CAT = /^(subwoofer|receiver|amplifier|speaker|projector|screen|turntable|cable|streamer|soundbar|headphones|cartridge|preamp|processor|dac)$/;
    function scKeywords(q) {
      var words = String(q || '').toLowerCase().replace(/\$\s?[\d,.]+k?/g, ' ').replace(/\b(\d+(?:\.\d+)?)k\b/g, function (m, n) { return +n >= 10 ? ' ' : m; }).replace(/[^a-z0-9.\- ]/g, ' ').split(/\s+/).filter(Boolean)
        .map(function (w) { return SC_SYN[w] || w; }).filter(function (w) { return SC_STOP.indexOf(w) < 0 && w.length > 1 && !/^\d+$/.test(w); });
      var seen = {}; words = words.filter(function (w) { if (seen[w]) return false; seen[w] = 1; return true; });
      var cat = words.filter(function (w) { return SC_CAT.test(w); });
      var rest = words.filter(function (w) { return !SC_CAT.test(w); });
      return cat.concat(rest);
    }
    function retrieve(terms) {
      return search1(terms).then(function (found) {
        if (found && found.length) return found;
        var kw = scKeywords(terms);
        var tries = [kw.slice(0, 3), kw.slice(0, 2), kw.slice(0, 1)].map(function (a) { return a.join(' '); })
          .filter(function (t, i, all) { return t && t !== String(terms).toLowerCase().trim() && all.indexOf(t) === i; });
        var step = function (i) { if (i >= tries.length) return Promise.resolve([]); return search1(tries[i]).then(function (f) { return (f && f.length) ? f : step(i + 1); }); };
        return step(0);
      });
    }
    function predictive(terms) {
      return fetch(routes + 'search/suggest.json?q=' + encodeURIComponent(terms) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,vendor,tag', { headers: { 'accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          return ps.map(function (p) { return { id: p.id, vid: (p.variants && p.variants[0] && p.variants[0].id) || 0, handle: p.handle, title: p.title, vendor: p.vendor || '', type: p.product_type || '', tags: p.tags || [], price: null, available: p.available !== false, variants: (p.variants && p.variants.length) || 1, url: p.url, image: (p.featured_image && p.featured_image.url) || p.image || '', options: {}, blurb: '' }; });
        })
        .catch(function () { return []; });
    }
    function trimCands(cands) {
      return cands.slice(0, 14).map(function (c) { return { id: c.id, handle: c.handle, vid: c.vid, title: c.title, vendor: c.vendor, type: c.type, tags: (c.tags || []).slice(0, 8), price: c.price, poa: !!c.poa, available: c.available, options: c.options || {}, blurb: (c.blurb || '').slice(0, 160) }; });
    }
    function normRefines(arr) {
      if (!Array.isArray(arr)) return null;
      return arr.slice(0, 4).map(function (r) { return (typeof r === 'string') ? { label: r, terms: r } : { label: r.label || r.terms || '', terms: r.terms || r.label || '' }; }).filter(function (r) { return r.label; });
    }

    function fallbackRender(q, cands) {
      if (cands && cands.length) {
        var picks = cands.slice(0, 4).map(function (p) { return { p: p, why: '' }; });
        addBot('Here are the closest matches I found for “' + q + '”. For tailored advice, a specialist can help below.', picks, null, null);
      } else {
        addBot('Sorry, I couldn’t reach the catalogue just now. A specialist can help you find the right product in a couple of minutes.', null, null, null);
      }
    }

    function mergeCands(found, prior) {
      var out = [], seen = {};
      (found || []).forEach(function (c) { if (c && c.handle && !seen[c.handle]) { seen[c.handle] = 1; out.push(c); } });
      (prior || []).forEach(function (c) { if (c && c.handle && !seen[c.handle]) { seen[c.handle] = 1; out.push(c); } });
      return out.slice(0, 16);
    }
    function send(text, terms) {
      if (busy) return;
      var q = (text || '').trim(); if (!q) return;
      busy = true; addUser(q); history.push({ role: 'user', text: q }); inputEl.value = '';
      track('query', { q: q, seeded: !!seedAsk });
      var searchTerms = (terms == null ? '' : String(terms)).trim();
      var typing = addTyping();
      var cands = [];
      // A chip with empty terms (e.g. "Compare top 2") reuses the products already shown, no re-search.
      var gather = (!searchTerms && lastShown.length)
        ? Promise.resolve(lastShown.slice())
        : retrieve(searchTerms || q).then(function (found) { return mergeCands(found, lastShown); });
      var focus = null;
      gather = Promise.all([gather, focusProduct()]).then(function (r) {
        focus = r[1];
        return focus ? mergeCands([focus], r[0]) : r[0];
      });
      gather.then(function (found) {
        cands = found || [];
        var payload = { op: 'assist', stream: 1, query: q, history: history.slice(-6), candidates: trimCands(cands), shown: lastShown.map(function (p) { return p.handle; }), intent: intentTerms, context: ctx(), sid: sid() };
        if (focus) payload.focus = { handle: focus.handle, title: focus.title, vendor: focus.vendor, type: focus.type, description: focus.description, specs: focus.specs, model: focus.model, warranty: focus.warranty, box: focus.box, options: focus.options, available: focus.available };
        var sep = proxy().indexOf('?') === -1 ? '?' : '&';
        var ac = ('AbortController' in window) ? new AbortController() : null;
        var acTimer = ac ? setTimeout(function () { ac.abort(); }, 30000) : null;
        var gotStep = false;
        var stepTimers = [
          setTimeout(function () { if (!gotStep) setStep(typing, guessStep(q, focus)); }, 900),
          setTimeout(function () { if (!gotStep) setStep(typing, 'Checking the details…'); }, 7000),
          setTimeout(function () { setStep(typing, 'Nearly there…'); }, 16000)
        ];
        var stopSteps = function () { stepTimers.forEach(clearTimeout); };
        return fetch(proxy() + sep + 'op=assist', { method: 'POST', headers: { 'content-type': 'application/json', 'accept': 'application/x-ndjson, application/json' }, body: JSON.stringify(payload), signal: ac ? ac.signal : undefined })
          .then(function (r) { return readAssist(r, function (t) { gotStep = true; setStep(typing, t); }); })
          .then(function (d) {
            if (acTimer) clearTimeout(acTimer); stopSteps();
            if (typing && typing.remove) typing.remove();
            if (d && d.ok) {
              var byHandle = {}; cands.forEach(function (c) { byHandle[c.handle] = c; });
              // Products Soundcheck found itself (catalogue search) arrive with their card data.
              (d.products || []).forEach(function (c) { if (c && c.handle && !byHandle[c.handle]) byHandle[c.handle] = c; });
              var picks = (d.picks || []).map(function (pk) { var p = byHandle[pk.handle]; return p ? { p: p, why: pk.why } : null; }).filter(Boolean);
              if (!picks.length && cands.length) picks = cands.slice(0, 3).map(function (p) { return { p: p, why: '' }; });
              var refs = normRefines(d.refinements);
              var note = '';
              addBot(d.answer || '', picks, refs, note);
              if (d.plan) savePlan(d.plan); // e1: what they told us lands in My System + builder hand-off
              if (d.handoff === 'deal') { handoffCard(); try { var hn = threadEl.querySelector('.cncg-ho textarea[name="note"]'); if (hn && !hn.value) hn.value = 'Asking for your best price' + (ctx().productTitle ? ' on the ' + ctx().productTitle : '') + '.'; } catch (e) {} } // price talk goes to a person, form first
              else if (d.escalate) humanCTA(); // offer the callback path when the AI can't confidently help
              track('results', { count: picks.length, escalate: !!d.escalate });
              if (picks.length) lastShown = picks.map(function (x) { return x.p; });
              if (d.searchTerms) intentTerms = String(d.searchTerms).slice(0, 80);
              history.push({ role: 'assistant', text: (d.answer || '').slice(0, 400), picks: snapPicks(picks), refines: refs, note: note }); saveHist();
            } else { fallbackRender(q, cands); if (cands && cands.length) lastShown = cands.slice(0, 4); saveHist(); }
            busy = false;
          });
      }).catch(function () { try { stepTimers.forEach(clearTimeout); } catch (e) {} if (typing && typing.remove) typing.remove(); fallbackRender(q, cands); if (cands && cands.length) lastShown = cands.slice(0, 4); saveHist(); busy = false; });
    }

    /* ---- e1: room / layout / budget the shopper stated go into My System (src soundcheck) and a
       "Open the System Builder with this" chip follows the reply. The builder seeds from the plan. ---- */
    var planShownAt = 0;
    function savePlan(pl) {
      if (!window.CHT || !CHT.system || !CHT.system.set) return;
      var wrote = false;
      try {
        if (pl.room && Object.keys(pl.room).length) { CHT.system.set('room', pl.room, 'soundcheck'); wrote = true; }
        var plan = {};
        if (pl.layout) plan.layout = pl.layout;
        if (pl.budget) plan.budget = pl.budget;
        if (pl.projector === true || pl.projector === false) plan.projector = pl.projector;
        if (Object.keys(plan).length) { CHT.system.set('plan', plan, 'soundcheck'); wrote = true; }
      } catch (e) { return; }
      if (!wrote || Date.now() - planShownAt < 120000) return;
      planShownAt = Date.now();
      var bits = [];
      if (pl.room && pl.room.L && pl.room.W) bits.push(pl.room.L + ' × ' + pl.room.W + ' m room');
      if (pl.layout) bits.push(pl.layout);
      if (pl.budget) bits.push('around $' + Math.round(pl.budget).toLocaleString('en-AU'));
      var d = document.createElement('div'); d.className = 'cncg-msg cncg-msg--bot';
      d.innerHTML = '<span class="cncg-orb-sm" aria-hidden="true"></span><div class="cncg-bubble"><p class="cncg-note">Saved to My System' + (bits.length ? ': ' + esc(bits.join(' · ')) : '') + '.</p>' +
        '<div class="cncg-refines"><a class="cncg-refine" href="' + routes + 'pages/system-builder">Open the System Builder with this</a><a class="cncg-refine" href="' + routes + 'pages/my-system">View My System</a></div></div>';
      threadEl.appendChild(d); scroll();
      track('plan_saved', { room: !!pl.room, layout: pl.layout || '', budget: pl.budget || 0 });
    }

    /* ---- human handoff: callback request with transcript ---- */
    function inHoursSyd() {
      try {
        var now = new Date();
        var dow = new Intl.DateTimeFormat('en-US', { timeZone: 'Australia/Sydney', weekday: 'short' }).format(now).slice(0, 3);
        var hr = parseInt(new Intl.DateTimeFormat('en-US', { timeZone: 'Australia/Sydney', hour: '2-digit', hourCycle: 'h23' }).format(now), 10);
        return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(dow) >= 0 && hr >= 9 && hr < 17;
      } catch (e) { return true; }
    }
    var hoOpen = false;
    function humanCTA() {
      var d = document.createElement('div'); d.className = 'cncg-msg cncg-msg--bot';
      d.innerHTML = '<span class="cncg-orb-sm" aria-hidden="true"></span><div class="cncg-bubble"><p class="cncg-ans">Prefer a real person? Leave your number and a specialist will call you' + (inHoursSyd() ? ', usually within 20 minutes.' : ' when the showroom opens (Mon–Fri 9am–5pm).') + '</p><div class="cncg-cta-row"><button type="button" class="cncg-refine" data-cncg-human>Request a callback</button><a class="cncg-refine" href="' + esc(cncg.getAttribute('data-book') || '/pages/book') + '">Book a consult →</a></div></div>';
      threadEl.appendChild(d); scroll();
    }
    function handoffCard() {
      if (hoOpen) { var ex = threadEl.querySelector('.cncg-ho'); if (ex) { try { ex.scrollIntoView({ block: 'center' }); ex.querySelector('input').focus(); } catch (e) {} return; } hoOpen = false; }
      hoOpen = true;
      var inH = inHoursSyd();
      var d = document.createElement('div'); d.className = 'cncg-msg cncg-msg--bot';
      d.innerHTML = '<span class="cncg-orb-sm" aria-hidden="true"></span><div class="cncg-bubble">' +
        '<p class="cncg-ans">' + (inH ? 'Leave your details and a specialist will call you back, usually within 20 minutes.' : 'The showroom is closed right now (Mon–Fri 9am–5pm). Leave your details and we’ll call you when we open, or we can simply reply by email.') + '</p>' +
        '<form class="cncg-ho" novalidate>' +
          '<input type="text" name="name" placeholder="Your name" autocomplete="name" aria-label="Your name">' +
          '<input type="tel" name="phone" placeholder="Mobile number" autocomplete="tel" aria-label="Mobile number">' +
          '<input type="email" name="email" placeholder="Email" autocomplete="email" aria-label="Email">' +
          '<div class="cncg-ho__times" role="group" aria-label="Preferred time">' +
            (inH ? '<button type="button" class="cncg-ho__time is-on" aria-pressed="true" data-t="asap">ASAP</button>' : '<button type="button" class="cncg-ho__time is-on" aria-pressed="true" data-t="morning">First thing (9am)</button>') +
            '<button type="button" class="cncg-ho__time" aria-pressed="false" data-t="lunch">Lunchtime</button>' +
            '<button type="button" class="cncg-ho__time" aria-pressed="false" data-t="after5">After 5pm</button>' +
          '</div>' +
          '<textarea name="note" placeholder="Anything we should know? (optional)"></textarea>' +
          (inH ? '' : '<label class="cncg-ho__row"><input type="checkbox" name="emailok" checked> An email reply is fine too</label>') +
          '<input class="cncg-ho__hp" type="text" name="cb_xtr" tabindex="-1" autocomplete="off" aria-hidden="true">' +
          '<p class="cncg-ho__err" role="alert"></p>' +
          '<button type="submit" class="cncg-ho__submit">Request my callback</button>' +
        '</form></div>';
      threadEl.appendChild(d); scroll();
      try { d.querySelector('input[name="name"]').focus(); } catch (e) {}
      track('handoff_open', { inHours: inH });
    }
    function submitCallback(form) {
      var els = form.elements;
      var err = form.querySelector('.cncg-ho__err');
      var name = els.name.value.trim(), phone = els.phone.value.trim(), email = els.email.value.trim();
      var bad = null;
      if (!name) bad = 'Please add your name.';
      else if (phone.replace(/\D/g, '').length < 8) bad = 'Please add a valid mobile number.';
      else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) bad = 'Please add a valid email.';
      if (bad) { err.textContent = bad; err.style.display = 'block'; return; }
      err.style.display = 'none';
      var btn = form.querySelector('.cncg-ho__submit'); btn.disabled = true; btn.textContent = 'Sending…';
      var tsel = form.querySelector('.cncg-ho__time.is-on');
      var payload = {
        name: name, phone: phone, email: email,
        preferTime: tsel ? tsel.getAttribute('data-t') : 'any',
        emailOk: !!(els.emailok && els.emailok.checked),
        note: els.note.value.trim().slice(0, 300),
        hp: els.cb_xtr.value,
        transcript: history.slice(-12).map(function (m) { return { role: m.role, text: String(m.text || '').slice(0, 300) }; }),
        context: { url: location.href, productTitle: (ctx().productTitle || ''), intent: intentTerms, shown: lastShown.slice(0, 4).map(function (p) { return { title: p.title, handle: p.handle }; }) }
      };
      var sep = proxy().indexOf('?') === -1 ? '?' : '&';
      /* sc11: on the Roomcheck page the specialist also gets the room summary and a link that opens it. */
      var rt = window.__rt, roomP = Promise.resolve(null);
      try { if (rt && typeof rt.soundcheck === 'function') { var rs = rt.soundcheck(); if (rs && rs.summary) payload.context.room = String(rs.summary).slice(0, 200); } } catch (e) {}
      try { if (rt && typeof rt.roomLink === 'function') roomP = Promise.race([rt.roomLink(), new Promise(function (res) { setTimeout(function () { res(null); }, 1500); })]).catch(function () { return null; }); } catch (e) {}
      roomP.then(function (link) { if (link) payload.context.roomLink = String(link); }).then(function () { return fetch(proxy() + sep + 'op=callback', { method: 'POST', headers: { 'content-type': 'application/json', 'accept': 'application/json' }, body: JSON.stringify(payload) }); })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.ok) { btn.disabled = false; btn.textContent = 'Request my callback'; err.textContent = (d && d.error) || 'Could not send, please call ' + CNCG_PHONE + '.'; err.style.display = 'block'; return; }
          hoOpen = false;
          var wrap = form.closest('.cncg-msg'); if (wrap) wrap.remove();
          /* The transcript claim used to be unconditional, so if the worker's mail leg failed the
             customer was told an email was on the way that never arrived. Only say it when the
             callback response confirms it (worker returns emailed: true). */
          var emailed = d.emailed === true;
          var emailNote = emailed ? ' We’ve emailed you a copy of this conversation.' : '';
          var replyNote = (emailed && payload.emailOk) ? ' If it’s easier, just reply to the email we’ve sent, it comes straight to the team.' : '';
          var msg = d.inHours
            ? 'Thanks ' + name + ', a specialist will call you on ' + phone + ' within about 20 minutes.' + emailNote
            : 'Thanks ' + name + ', we’re back in the showroom at 9am and will call you then.' + replyNote + emailNote;
          addBot(msg, null, null, null);
          /* The confirmation reads back the customer's name and phone number. It stays on screen,
             but history is persisted to sessionStorage — on a shared showroom device the next
             visitor would find it there. Persist a PII-free version of the same turn. */
          history.push({ role: 'assistant', text: (d.inHours
            ? 'Thanks, a specialist will call you within about 20 minutes.'
            : 'Thanks, we’re back in the showroom at 9am and will call you then.') + emailNote });
          saveHist();
          track('handoff_sent', { inHours: !!d.inHours });
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Request my callback'; err.textContent = 'Network error, please call ' + CNCG_PHONE + '.'; err.style.display = 'block'; });
    }

    /* ---- events ---- */
    document.addEventListener('click', function (e) {
      var human = e.target.closest('[data-cncg-human]');
      if (human) { e.preventDefault(); if (!cncg.classList.contains('is-open')) open(human); handoffCard(); return; }
      var trig = e.target.closest('[data-cncg-open], a[href="#concierge"], a[href$="#concierge"]');
      if (trig) { e.preventDefault(); open(trig); return; }
      if (e.target.closest('[data-cncg-close]')) { close(); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cncg.classList.contains('is-open')) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !cncg.classList.contains('is-open')) return;
      var f = [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    threadEl.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.cncg-pc__add');
      if (addBtn) { e.preventDefault(); quickAdd(addBtn); return; }
      var tbtn = e.target.closest('.cncg-ho__time');
      if (tbtn) {
        [].forEach.call(tbtn.parentElement.children, function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
        tbtn.classList.add('is-on'); tbtn.setAttribute('aria-pressed', 'true');
        return;
      }
      var chip = e.target.closest('button.cncg-refine');
      if (chip && !chip.hasAttribute('data-cncg-human')) { track('refine', { label: chip.textContent }); send(chip.textContent, chip.getAttribute('data-terms')); return; }
      var view = e.target.closest('[data-view-handle]');
      if (view) { track('view', { handle: view.getAttribute('data-view-handle') }); }
    });
    threadEl.addEventListener('submit', function (e) {
      var f = e.target.closest('.cncg-ho');
      if (f) { e.preventDefault(); submitCallback(f); }
    });
    formEl.addEventListener('submit', function (e) { e.preventDefault(); send(inputEl.value); });
  })();
